import { useAppContext } from '@contexts/app';
import { SignIn } from './signIn';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';
import { localStore } from '@utils/localStore';
import { PageLoader } from '@components/page/loader';
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router';

export const DefaultView = () => {
  const {
    isLogged,
    admin: { isLogged: isAdminLogged },
    isForeman,
    isManager,
    isCadTechnician,
  } = useAppContext();

  const navigate = useNavigate();

  const admin = isAdminLogged || localStore.getItem('app-admin');
  const user = isLogged || localStore.getItem('app-user');

  useEffect(() => {
    if (!user && admin) void navigate(parseRoute(`/${appRoutes.panel}`));
    if (!user) return;
    if (isForeman) void navigate(parseRoute(`/${appRoutes.foremanSchedules}`));
    if (isManager) void navigate(parseRoute(`/${appRoutes.hotSeat}`));
    if (isCadTechnician) void navigate(parseRoute(`/${appRoutes.jobs}`));
  }, [user, admin, isForeman, isManager, isCadTechnician, navigate]);

  if (!user && !admin) return <SignIn />;
  if (!user && admin) return <Navigate to={parseRoute(`/${appRoutes.panel}`)} replace />;
  if (isForeman) {
    <Navigate to={parseRoute(`/${appRoutes.foremanSchedules}`)} replace />;
    return;
  }
  if (isManager) return <Navigate to={parseRoute(`/${appRoutes.hotSeat}`)} replace />;
  if (isCadTechnician) return <Navigate to={parseRoute(`/${appRoutes.jobs}`)} replace />;
  return <PageLoader />;
};
